'use client'; // Error components must be Client Components

import PageContainer from '@/components/UI/Page/PageContainer';
import Title from '@/components/UI/Title';
import { Button } from '@chakra-ui/react';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <PageContainer>
      <Title>Something went wrong!</Title>
      <Button onClick={() => reset()}>Try again</Button>
    </PageContainer>
  );
}
